import React, { useEffect, useRef, useContext } from "react"
import { Link } from "react-router-dom"
import { ContextProvider } from "../context/Context"

import { AiFillCloseCircle } from "react-icons/ai"

interface Iprops {
  nav: boolean
  setNav: React.Dispatch<React.SetStateAction<boolean>>
}

const SideNav: React.FC<Iprops> = ({ nav, setNav }) => {
  const divRef = useRef<HTMLDivElement>(null)
  const { dispatch } = useContext<any>(ContextProvider)

  useEffect(() => {
    if (nav) {
      divRef.current?.classList.remove("-translate-x-full")
    } else {
      divRef.current?.classList.add("-translate-x-full")
    }
  }, [nav])

  return (
    <div
      className="fixed top-0 left-0 flex flex-col items-center justify-center w-full h-full p-12 transition-all duration-300 shadow-sm bg-slate-600 shadow-slate-300 lg:w-1/4"
      ref={divRef}
      onClick={(c) => {
        setNav(!c)
      }}
    >
      <div className="absolute text-xl cursor-pointer top-10 right-10 md:text-2xl">
        <AiFillCloseCircle />
      </div>
      <ul className="flex flex-col items-center space-y-12 text-lg text-slate-200">
        <li
          className="hover:cursor-pointer hover:text-slate-400"
          onClick={() => {
            dispatch({ type: "LOGOUT" })
          }}
        >
          Logout
        </li>

        <Link to="/addUser">
          <li className="text-center hover:cursor-pointer hover:text-slate-400">
            Create New Account
          </li>
        </Link>

        <Link to="/about">
          <li className="hover:cursor-pointer hover:text-slate-400">About</li>
        </Link>
      </ul>
    </div>
  )
}

export default SideNav
